import { useState } from "react";
import { MdOutlineRateReview } from "react-icons/md";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import AccountLayout from "./AccountLayout";
import { usePendingReviews, useSubmitReview } from "../libs/useReviews";
import { AccountReviewsSkeleton } from "./AccountSkeletons";
import "./UserProfile.css";

const Pendingreview = () => {
  const { data: pending = [], isLoading } = usePendingReviews();
  const { mutate: submitReview } = useSubmitReview();
  const [drafts, setDrafts] = useState({});

  const handleSubmit = (item) => {
    const draft = drafts[item.product?._id || item.productName] || { rating: 5, comment: "" };
    submitReview(
      {
        productId: item.product?._id || item.product,
        orderId: item.orderId,
        rating: draft.rating,
        comment: draft.comment,
      },
      {
        onSuccess: () => toast.success("Review submitted"),
        onError: (err) => toast.error(err.response?.data?.message || "Could not submit review"),
      }
    );
  };

  if (isLoading) {
    return (
      <AccountLayout loading>
        <AccountReviewsSkeleton />
      </AccountLayout>
    );
  }

  return (
    <AccountLayout title="Pending Evaluation">
      {pending.length === 0 && (
        <div className="account-empty">
          <div className="account-empty__icon">
            <MdOutlineRateReview />
          </div>
          <h3>No pending reviews</h3>
          <p>Delivered orders will appear here for you to review.</p>
          <Link to="/account/orders" className="account-btn account-btn--ghost">
            View orders
          </Link>
        </div>
      )}
      {pending.map((item) => {
        const key = item.product?._id || item.productName;
        const draft = drafts[key] || { rating: 5, comment: "" };
        return (
          <div key={`${item.orderId}-${key}`} className="review-card">
            {item.productImage && (
              <img src={item.productImage} alt={item.productName} className="review-product-thumb" />
            )}
            <p>
              <strong>{item.productName}</strong> — Order {item.orderNumber}
            </p>
            <div>
              <label htmlFor={`rating-${key}`}>Rating</label>
              <select
                id={`rating-${key}`}
                value={draft.rating}
                onChange={(e) =>
                  setDrafts({ ...drafts, [key]: { ...draft, rating: Number(e.target.value) } })
                }
              >
                {[5, 4, 3, 2, 1].map((r) => (
                  <option key={r} value={r}>
                    {r} stars
                  </option>
                ))}
              </select>
            </div>
            <textarea
              placeholder="Write your review..."
              value={draft.comment}
              onChange={(e) =>
                setDrafts({ ...drafts, [key]: { ...draft, comment: e.target.value } })
              }
            />
            <button
              type="button"
              className="account-btn account-btn--primary"
              onClick={() => handleSubmit(item)}
            >
              Submit review
            </button>
          </div>
        );
      })}
    </AccountLayout>
  );
};

export default Pendingreview;
